'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SecondaryButton = require('./components/SecondaryButton.component');

var _SecondaryButton2 = _interopRequireDefault(_SecondaryButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SecondaryButton2.default; /*
                                              * Exports
                                              */


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-buttons/lib/components/secondary/index.js
// module id = 438
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 15